import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { affiliatesService } from '../api/affiliates.service';

export function useAffiliatesListQuery(withStats = true) {
  return useQuery({
    queryKey: queryKeys.affiliates.list(withStats),
    queryFn: () => affiliatesService.list({ withStats }),
  });
}
